import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { SxHttpService } from "./sxHttp.service";
import { CategoryList } from "../model/interfaces/categoryList.interface";

@Injectable()
export class CategoryListService {
  private categoryListService = "api/menuCategory";

  constructor(private http: Http, private sxHttp: SxHttpService) {}
  //#region standard persistence
  getAll(subscriptionCode,channelCode): Observable<CategoryList[]> {
    return this.sxHttp
      .get(`${this.categoryListService}/${subscriptionCode}/${channelCode}`)
      .map((response) => {
        return response.json().data as CategoryList[]
      });
  }

  getById(idCategoryList: string): Observable<CategoryList> {
    return this.sxHttp
      .get(`${this.categoryListService}/${idCategoryList}`)
      .map((response) => response.json().data as CategoryList);
  }

  delete(idCategoryList: string): Promise<Boolean> {
    return this.sxHttp
      .delete(`${this.categoryListService}/${idCategoryList}`)
      .toPromise()
      .then((result) => result.json().data);
  }

  create(model: CategoryList): Promise<any> {
    return this.sxHttp
      .post(this.categoryListService, model)
      .toPromise()
      .then((response) => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/categoryList.service.ts